import { TPricingPlans } from '../../S/pricing/types';
import { extractPlanWFromId } from '../../Utils/CommonUtils';
import { getItrType } from './data';
import { PriceTableHeader } from './price-table-header';

export type TPRICE_TABLE_BODY = {
  income: string;
  columns?: Array<JSX.Element | null>;
};

interface PRICE_TABLE_PROPS {
  bodyData: TPRICE_TABLE_BODY[];
  plansList: Array<string>;
  priceMapData: Record<string, TPricingPlans>;
}

export const PriceTable = ({
  bodyData,
  plansList,
  priceMapData,
}: PRICE_TABLE_PROPS): JSX.Element => {
  const planData = extractPlanWFromId(plansList, priceMapData);

  return (
    <table
      className="w-full stripe-table blueBg table-auto"
      data-testid="price-table"
    >
      <tr>
        <th></th>
        {planData?.map((item) => {
          const plan = item.planDetails;
          const totalAmountInteger = ~~plan.pricing?.discountedPrice;
          const originalAmountInteger = ~~plan.pricing?.listPrice;
          const id = item.externalId;
          const itrString =
            getItrType[item.externalId as keyof typeof getItrType];
          return (
            <th key={item.externalId}>
              <PriceTableHeader
                planName={plan.name}
                finalPrice={totalAmountInteger}
                originalPrice={originalAmountInteger}
                itr={itrString}
                planId={id}
                priceMapData={priceMapData}
              />
            </th>
          );
        })}
      </tr>
      {bodyData.map((item) => (
        <tr key={item.income}>
          <td className="font-medium">{item.income}</td>
          {item.columns?.map((column, index) => (
            <td key={index + item.income}>{column}</td>
          ))}
        </tr>
      ))}
    </table>
  );
};
